// Global ID for the element.
export const ELEMENT_ID = 'firebaseui_container';
